export enum SearchableSettings {
    MIN_ITEM_COUNT = 50,
    MAX_ITEM_RESULT = 500,
    INFINITE_SCROLL_ITEM_INCREMENT = 50,
}
